/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Termsagreed_Ticketsize_Description3Inputs */

const en_coinvestments_termsagreed_ticketsize_description3 = /** @type {(inputs: Coinvestments_Termsagreed_Ticketsize_Description3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Indicative investment range in consideration`)
};

/**
* | output |
* | --- |
* | "Your Indicative investment range in consideration" |
*
* @param {Coinvestments_Termsagreed_Ticketsize_Description3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_termsagreed_ticketsize_description3 = /** @type {((inputs?: Coinvestments_Termsagreed_Ticketsize_Description3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Termsagreed_Ticketsize_Description3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_termsagreed_ticketsize_description3(inputs)
});
export { coinvestments_termsagreed_ticketsize_description3 as "coInvestments_termsAgreed_ticketSize_description" }